<template>
    <Poptip placement="bottom-start" transfer trigger="hover">
        <div class="banner-status-indicator">
            <QaStatusDot :status="status" />
        </div>
        <template #content>
            <QaStatusDot :status="status" />
            {{ statusLabel }}
        </template>
    </Poptip>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";

import QaStatusDot from "@/components/Qa/QaStatusDot.vue";
import { BannerQaStatusLabel } from "@/enums/filters";
import { DeliverableLibraryGetters } from "@/store/modules/deliverableLibrary";
import type { ConstructedDeliverable } from "@/types/types";

export default defineComponent({
    components: {
        QaStatusDot
    },
    props: {
        deliverable: {
            required: true,
            type: Object as PropType<ConstructedDeliverable>
        }
    },
    computed: {
        statusLabel() {
            return BannerQaStatusLabel[this.status as keyof typeof BannerQaStatusLabel];
        },
        status() {
            return this.$store.getters[DeliverableLibraryGetters.computedDeliverableStatus](this.deliverable.idHash);
        }
    }
});
</script>

<style lang="scss">
@use "@style/variables" as *;

$size: 40px;

.banner-status-indicator {
    align-items: center;
    display: flex;
    height: $size;
    justify-content: center;
    position: relative;
    width: $size;
}
</style>
